import { useCurrentUser } from '../hooks/useCurrentUser'
import { AppShell } from './AppShell'
import { WebsiteShell } from './WebsiteShell'

export function PrimaryShell() {
  const user = useCurrentUser()

  return user.status === 'participant' ? <AppShell /> : <WebsiteShell />
}
